import React, { useRef, useEffect, useState } from "react";
import { easepick, LockPlugin } from "@easepick/bundle";
import { useApp } from "@store/app";
import { useDocument } from "@hooks/useDocument";

interface IProps {
  monthsToShow?: number;
  value?: string;
  onChange?: (value: string) => void;
}

const Calendar = ({ monthsToShow = 2, value, onChange }: IProps) => {
  const date = useApp(($) => $.date);
  const setDate = useApp(($) => $.setDate);

  let calendar = useRef(null);
  const [easeObj, setEase] = useState<easepick.Core>();
  const doc = useDocument();

  useEffect(() => {
    if (easeObj) {
    }
  }, [easeObj]);

  useEffect(() => {
    if (!calendar.current) return;

    if (easeObj) {
      easeObj.destroy();
    }

    let ease = new easepick.create({
      element: calendar.current,

      css: ["/calendar.css"],
      plugins: [LockPlugin],
      LockPlugin: {
        minDate: new Date(),
      },
      date: value || date,
      inline: true,

      zIndex: 10,
      grid: monthsToShow,
      calendars: monthsToShow,
      setup(picker) {
        // add price to day element
        picker.on("select", (evt) => {
          const { date } = evt.detail;
          if (onChange) {
            onChange(date.format("YYYY-MM-DD"));
          } else {
            setDate(date.format("YYYY-MM-DD"));
          }
        });
        picker.on("view", (evt) => {
          const { view, date, target } = evt.detail;
          const d = date ? date.format("YYYY-MM-DD") : null;

          if (view === "CalendarDay" && date >= new Date()) {
            const span =
              target.querySelector(".day-price") ||
              (doc && doc.createElement("span"));
            if (span) {
              span.className = "bg-red day-price";
              if ("innerHTML" in span)
                //span.innerHTML = `<div style="background-color:#A2C714;width:8px;height:8px;text-align:center;border-radius:100%;"/>`;
                target.append(span);
            }
          }
        });
      },
    });

    setEase(ease);
  }, [calendar, value, doc]);

  return <div ref={calendar} className="hidden" id="calendar" />;
};

export default Calendar;
